<template>
  <div style="height: 100vh;">
    <iframe src="screenHome/index.html" frameborder="0" width="100%" height="100%" name="极速DSP"></iframe>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  mounted() {
    window.addEventListener("message", this.loadFile);
  },
  methods: {
    loadFile(e) {
      if (e.data === "login") {
        this.$router.push("/login");
      } else if (e.data === "register") {
        this.$router.push({ path: '/register', query: { step: 1, method: 1 } })
      }
    }
  },
}
</script>
